import { render } from "./ReportAI.vue?vue&type=template&id=0b4a7b0a&scoped=true"
import script from "./ReportAI.vue?vue&type=script&lang=js"
export * from "./ReportAI.vue?vue&type=script&lang=js"

import "./ReportAI.vue?vue&type=style&index=0&id=0b4a7b0a&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4a7b0a"]])

export default __exports__